/* eslint-disable no-alert */
import { useState } from 'react';
import moment from 'moment';

const TERMS = {
  specialStart: 'Tanggal Mulai Promo Special',
  specialEnd: 'Tanggal Berakhir Promo Special',
  earlyStart: 'Tanggal Mulai Early Bird',
  earlyEnd: 'Tanggal Berakhir Early Bird',
  termStart: 'Tanggal Mulai Promo Term',
  termEnd: 'Tanggal Berakhir Promo Term',
  term2Start: 'Tanggal Mulai Promo Term 2',
  term2End: 'Tanggal Berakhir Promo Term 2',
  normalPromoStart: 'Tanggal Mulai Promo Normal',
  normalPromoEnd: 'Tanggal Berakhir Promo Normal',
};

/*
 * Cross-field ordering rules for the 8 clearable promo pickers.
 * `against: 'startDate'` rules run unconditionally; every other rule only
 * runs when the referenced field has a value. `failWhen: 'after'` fails when
 * the picked date is later than the referenced one, 'before' when earlier.
 */
const PROMO_DATE_RULES = {
  specialStartDate: {
    boundary: 'startOf',
    pickerKey: 'datePickerSpecialStartDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.specialStart} harus sebelum Start Date`,
      },
      {
        against: 'specialEndDate',
        failWhen: 'after',
        message: `${TERMS.specialStart} harus sebelum ${TERMS.specialEnd}`,
      },
    ],
  },
  specialEndDate: {
    boundary: 'endOf',
    pickerKey: 'datePickerSpecialEndDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.specialEnd} harus sebelum Start Date`,
      },
      {
        against: 'specialStartDate',
        failWhen: 'before',
        message: `${TERMS.specialEnd} harus sesudah ${TERMS.specialStart}`,
      },
    ],
  },
  earlyStartDate: {
    boundary: 'startOf',
    pickerKey: 'datePickerEarlyStartDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.earlyStart} harus sebelum Start Date`,
      },
      {
        against: 'earlyEndDate',
        failWhen: 'after',
        message: `${TERMS.earlyStart} harus sebelum ${TERMS.earlyEnd}`,
      },
    ],
  },
  earlyEndDate: {
    boundary: 'endOf',
    pickerKey: 'datePickerEarlyEndDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.earlyEnd} harus sebelum Start Date`,
      },
      {
        against: 'earlyStartDate',
        failWhen: 'before',
        message: `${TERMS.earlyEnd} harus sesudah ${TERMS.earlyStart}`,
      },
      {
        against: 'termStartDate',
        failWhen: 'after',
        message: `${TERMS.earlyEnd} harus sebelum ${TERMS.termStart}`,
      },
    ],
  },
  termStartDate: {
    boundary: 'startOf',
    pickerKey: 'datePickerTermStartDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.termStart} harus sebelum Start Date`,
      },
      {
        against: 'termEndDate',
        failWhen: 'after',
        message: `${TERMS.termStart} harus sebelum ${TERMS.termEnd}`,
      },
      {
        against: 'earlyEndDate',
        failWhen: 'before',
        message: `${TERMS.termStart} harus sesudah ${TERMS.earlyEnd}`,
      },
    ],
  },
  termEndDate: {
    boundary: 'endOf',
    pickerKey: 'datePickerTermEndDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.termEnd} harus sebelum Start Date`,
      },
      {
        against: 'termStartDate',
        failWhen: 'before',
        message: `${TERMS.termEnd} harus sesudah ${TERMS.termStart}`,
      },
      {
        against: 'earlyEndDate',
        failWhen: 'before',
        message: `${TERMS.termEnd} harus sesudah ${TERMS.earlyEnd}`,
      },
      {
        against: 'term2StartDate',
        failWhen: 'after',
        message: `${TERMS.termEnd} harus sebelum ${TERMS.term2Start}`,
      },
    ],
  },
  term2StartDate: {
    boundary: 'startOf',
    pickerKey: 'datePickerTerm2StartDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.term2Start} harus sebelum Start Date`,
      },
      {
        against: 'term2EndDate',
        failWhen: 'after',
        message: `${TERMS.term2Start} harus sebelum ${TERMS.term2End}`,
      },
      {
        against: 'termEndDate',
        failWhen: 'before',
        message: `${TERMS.term2Start} harus sesudah ${TERMS.termEnd}`,
      },
    ],
  },
  term2EndDate: {
    boundary: 'endOf',
    pickerKey: 'datePickerTerm2EndDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.term2End} harus sebelum Start Date`,
      },
      {
        against: 'term2StartDate',
        failWhen: 'before',
        message: `${TERMS.term2End} harus sesudah ${TERMS.term2Start}`,
      },
      {
        against: 'termEndDate',
        failWhen: 'before',
        message: `${TERMS.term2End} harus sesudah ${TERMS.termEnd}`,
      },
      {
        against: 'normalPromoStartDate',
        failWhen: 'after',
        message: `${TERMS.term2End} harus sebelum ${TERMS.normalPromoStart}`,
      },
    ],
  },
  normalPromoStartDate: {
    boundary: 'startOf',
    pickerKey: 'datePickerNormalPromoStartDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.normalPromoStart} harus sebelum Start Date`,
      },
      {
        against: 'normalPromoEndDate',
        failWhen: 'after',
        message: `${TERMS.normalPromoStart} harus sebelum ${TERMS.normalPromoEnd}`,
      },
      {
        against: 'term2EndDate',
        failWhen: 'before',
        message: `${TERMS.normalPromoStart} harus sesudah ${TERMS.term2End}`,
      },
    ],
  },
  normalPromoEndDate: {
    boundary: 'endOf',
    pickerKey: 'datePickerNormalPromoEndDate',
    rules: [
      {
        against: 'startDate',
        failWhen: 'after',
        message: `${TERMS.normalPromoEnd} harus sebelum Start Date`,
      },
      {
        against: 'normalPromoStartDate',
        failWhen: 'before',
        message: `${TERMS.normalPromoEnd} harus sesudah ${TERMS.normalPromoStart}`,
      },
      {
        against: 'term2EndDate',
        failWhen: 'before',
        message: `${TERMS.normalPromoEnd} harus sesudah ${TERMS.term2End}`,
      },
    ],
  },
};

// Promo/sale date handlers + the manually controlled open state of the
// 11 date pickers.
const usePromoDates = (fields, setField, setFields) => {
  const [openPickers, setOpenPickers] = useState({});

  const openDatePicker = (key) =>
    setOpenPickers((prev) => ({ ...prev, [key]: true }));
  const closeDatePicker = (key) =>
    setOpenPickers((prev) => ({ ...prev, [key]: false }));

  const makePromoDateHandler = (fieldName) => {
    const { boundary, pickerKey, rules } = PROMO_DATE_RULES[fieldName];

    return (dateInput) => {
      if (dateInput === null) {
        setField(fieldName, { value: null, valid: true });
        return;
      }

      const date = new Date(moment(dateInput)[boundary]('day'));

      const failed = rules.find((rule) => {
        const against = fields[rule.against].value;
        if (rule.against !== 'startDate' && !against) return false;
        return rule.failWhen === 'after' ? date > against : date < against;
      });

      if (failed) {
        alert(failed.message);
        return;
      }

      setField(fieldName, { value: date, valid: true });
      closeDatePicker(pickerKey);
    };
  };

  const handleSpecialStartDate = makePromoDateHandler('specialStartDate');
  const handleSpecialEndDate = makePromoDateHandler('specialEndDate');
  const handleEarlyStartDate = makePromoDateHandler('earlyStartDate');
  const handleEarlyEndDate = makePromoDateHandler('earlyEndDate');
  const handleTermStartDate = makePromoDateHandler('termStartDate');
  const handleTermEndDate = makePromoDateHandler('termEndDate');
  const handleTerm2StartDate = makePromoDateHandler('term2StartDate');
  const handleTerm2EndDate = makePromoDateHandler('term2EndDate');
  const handleNormalPromoStartDate = makePromoDateHandler(
    'normalPromoStartDate',
  );
  const handleNormalPromoEndDate = makePromoDateHandler('normalPromoEndDate');

  // Sale End Date: not clearable, day-truncated comparison against startDate
  const handleSaleEndDate = (dateInput) => {
    const date = new Date(moment(dateInput).endOf('day'));
    const selectedDate = new Date(date?.toDateString());
    const startDate = new Date(fields.startDate.value?.toDateString());

    if (selectedDate > startDate) {
      alert(`Sale End Date harus sebelum Start Date`);
    } else {
      setField('saleEndDate', { value: date, valid: true });
      closeDatePicker('datePickerSaleEndDate');
    }
  };

  // The corporate pair never alerts on ordering conflicts within the pair;
  // it silently clamps the opposite bound instead. Its only alert is
  // against Sale End Date.
  const handleCorporateSaleStartDate = (dateInput) => {
    if (dateInput === null) {
      setField('corporateSaleStartDate', { value: null, valid: true });
      return;
    }

    const { corporateSaleEndDate, saleEndDate } = fields;

    let corporateSaleEndDateValue = corporateSaleEndDate.value;

    const givenDate = new Date(moment(dateInput).startOf('day'));
    const startOfSaleEndDate = new Date(
      moment(saleEndDate.value).startOf('day'),
    );

    if (givenDate > startOfSaleEndDate) {
      alert('Tanggal mulai Corporate Sale harus sebelum Sale End Date');
      return;
    }

    if (givenDate > corporateSaleEndDateValue) {
      corporateSaleEndDateValue = givenDate;
    }

    setFields({
      corporateSaleStartDate: { value: givenDate, valid: true },
      corporateSaleEndDate: { value: corporateSaleEndDateValue },
    });

    closeDatePicker('datePickerCorporateSaleStartDate');
  };

  const handleCorporateSaleEndDate = (dateInput) => {
    if (dateInput === null) {
      setField('corporateSaleEndDate', { value: null, valid: true });
      return;
    }

    const { corporateSaleStartDate, saleEndDate } = fields;

    let corporateSaleStartDateValue = corporateSaleStartDate.value;

    const givenDate = new Date(moment(dateInput).endOf('day'));
    const endOfSaleEndDate = new Date(moment(saleEndDate.value).endOf('day'));

    if (givenDate > endOfSaleEndDate) {
      alert('Tanggal berakhir Corporate Sale harus sebelum Sale End Date');
      return;
    }

    if (givenDate < corporateSaleStartDateValue) {
      corporateSaleStartDateValue = givenDate;
    }

    setFields({
      corporateSaleEndDate: { value: givenDate, valid: true },
      corporateSaleStartDate: { value: corporateSaleStartDateValue },
    });

    closeDatePicker('datePickerCorporateSaleEndDate');
  };

  return {
    openPickers,
    openDatePicker,
    closeDatePicker,
    handleSpecialStartDate,
    handleSpecialEndDate,
    handleEarlyStartDate,
    handleEarlyEndDate,
    handleTermStartDate,
    handleTermEndDate,
    handleTerm2StartDate,
    handleTerm2EndDate,
    handleNormalPromoStartDate,
    handleNormalPromoEndDate,
    handleSaleEndDate,
    handleCorporateSaleStartDate,
    handleCorporateSaleEndDate,
  };
};

export default usePromoDates;
